import Form from './form'
import React, { useState } from 'react'
import { ProgramContentType } from 'common/enum'

export default function (props) {
  const [data, setData] = useState({ content_type: ProgramContentType.ProgramWorkout, active: false })

  return <Form data={data} setData={setData} {...props} />
}
